import React from "react";

import { useFormalizrContext } from "@2po/formalizr";

import * as style from "./style.module.scss";

import { type FormalizrContext } from "@types";
import { useContentfulFormalizr } from "@hooks";

type FormalizrButtonWrapperProps = {
    children: string;
};

const FormalizerButtonWrapper = ({ children }: FormalizrButtonWrapperProps) => {
    const context: FormalizrContext = useFormalizrContext() ?? {
        translations: {},
        errors: {},
    };

    const { translations } = useContentfulFormalizr();
    const hasErrors = () => {
        const errors = context.errors;

        if (Object.keys(errors).length) {
            console.error("VALIDATION ERROR FORM:", errors);
            return true;
        }

        return false;
    };

    return (
        <div className={style.container}>
            <div className={style.buttonsContainer}>{children}</div>
            {hasErrors() && (
                <div className={style.errorMessage}>
                    {translations.submitError}
                </div>
            )}
        </div>
    );
};

export default FormalizerButtonWrapper;
